import './Footer.css';
import { Link } from 'react-router';

function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="row">
          <div className="col-sm-8">
            <p className='copyright'>Phoenix Unity Designs {new Date().getFullYear()} &copy;</p>
          </div>
          <div className="col-sm-4 text-end">
            <p className="other-links"><Link to="/privacy-policy">Privacy Policy</Link></p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
